import React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { IPermitTypeField } from '~/client/graph/types.generated'
import IPermitFieldsStore from '~/client/src/shared/models/IPermitFieldsStore'

import SitePermitCreationFormStore from '../../../WorkflowCreationForm.store'
import PermitFormFieldWrapper from '../../PermitFormFieldWrapper'
import PermitFieldRemoveIcon from '../PermitFieldRemoveIcon'
import WorkflowFormFieldViewMode from './WorkflowFormFieldViewMode'

// localization: no text to translate

interface IProps<T> {
  value: T
  index: number
  typeField: IPermitTypeField
  conditionalFields: IPermitTypeField[]
  conditionalParentInstanceId: string
  isViewMode: boolean
  hasMultipleValues: boolean
  isTitleShown: boolean
  componentRenderer(
    value: T,
    index: number,
    isHeaderShown?: boolean,
  ): JSX.Element

  store: SitePermitCreationFormStore
  fieldsStore: IPermitFieldsStore

  viewModeRenderer?(value: T): JSX.Element

  isViewModeContentFullWidth?: boolean
  titleRenderer?(value: T, index: number): JSX.Element | null

  onRemoveField?(index: number): void
}

function WorkflowFormFieldValue<T>({
  value,
  index,
  typeField,
  conditionalFields,
  isViewMode,
  conditionalParentInstanceId,
  fieldsStore,
  store,
  hasMultipleValues,
  isTitleShown,
  componentRenderer,
  viewModeRenderer,
  isViewModeContentFullWidth,
  titleRenderer,
  onRemoveField,
}: IProps<T>) {
  const shouldShowTitle = hasMultipleValues && isTitleShown

  return (
    <>
      {shouldShowTitle &&
        (titleRenderer ? (
          titleRenderer(value, index)
        ) : (
          <div className="x-between py10 px16 row">
            <div className="text extra-large bold">
              #{index + 1} {typeField.caption}
            </div>
            {!isViewMode && (
              <PermitFieldRemoveIcon index={index} onClick={onRemoveField} />
            )}
          </div>
        ))}
      <div
        className={classList({
          px16: shouldShowTitle || conditionalFields.length > 0,
          'tw:mt-1': isViewMode && index > 0 && !shouldShowTitle,
        })}
      >
        {isViewMode ? (
          <WorkflowFormFieldViewMode
            value={value}
            typeField={typeField}
            isTitleShown={
              (!index || shouldShowTitle) && !(shouldShowTitle && titleRenderer)
            }
            isPaddingAdded={!!conditionalFields.length}
            viewModeRenderer={viewModeRenderer}
            isContentFullWidth={isViewModeContentFullWidth}
          />
        ) : (
          componentRenderer(value, index, isTitleShown)
        )}
        {conditionalFields.map(field => (
          <PermitFormFieldWrapper
            key={field.id}
            typeField={field}
            parentInstanceId={conditionalParentInstanceId}
            parentValueIndex={index}
            store={store}
            fieldsStore={fieldsStore}
            isViewMode={isViewMode}
          />
        ))}
      </div>
    </>
  )
}

export default observer(WorkflowFormFieldValue)
